import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import React from 'react';
import SwitchIcon from '@mui/icons-material/SwapHoriz';
import {connect} from 'react-redux';
import {func, object} from 'prop-types';
import {styled} from '@mui/material/styles';

import {getFullCompareSubjects} from '@explorer/selectors/compare';
import {swapCompareSubjects} from '@explorer/actions/compare.js';

const SwitchButton = styled(Fab)(({theme}) => ({
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.grey[900],
  },
}));

const CompareSwitcher = props => {
  const onSwitchClick = () => {
    props.dispatch(swapCompareSubjects());
  };

  const hidden = !(props.subjects[0] && props.subjects[1]);

  return (
    <Box mx={2} visibility={hidden ? 'hidden' : 'visible'}>
      <SwitchButton
        aria-label="switch"
        size="small"
        color="inherit"
        hidden={hidden}
        onClick={onSwitchClick}
      >
        <SwitchIcon />
      </SwitchButton>
    </Box>
  );
};

CompareSwitcher.propTypes = {
  dispatch: func.isRequired,
  subjects: object.isRequired,
};

const mapStateToProps = state => ({
  subjects: getFullCompareSubjects(state),
});

export default connect(mapStateToProps)(CompareSwitcher);
